import * as React from "react";
import { RouteComponentProps } from "react-router";
import streamOfflineImage from "images/stream_offline.png";
import Card from "../core/Card";
import Player from "../core/Player";
import { Link } from "react-router-dom";
import { checkStreamLive, getStreamUrl } from "../../libs/streams";
import Loader from "../core/Loader";

const academyAgendaUrl = "https://chartec.net/academy-agenda/";

const streamNames = {
  arrc: "ARRC Training Room",
  chartec: "CharTec Main Room",
};

interface IProps extends RouteComponentProps<{ streamName: string }> {}

interface IState {
  showStream: boolean;
  loading: boolean;
  streamUrl?: string;
}

class StreamPlayer extends React.Component<IProps, IState> {
  state: Readonly<IState> = { showStream: false, loading: true };

  async componentDidMount() {
    const { streamName } = this.props.match.params;

    if (await checkStreamLive(streamName)) {
      this.setState({
        showStream: true,
        loading: false,
        streamUrl: getStreamUrl(streamName),
      });
    } else {
      this.setState({ showStream: false, loading: false });
    }
  }

  render() {
    const { streamName } = this.props.match.params;
    const { loading, showStream, streamUrl } = this.state;
    let show = (
      <div className={"columns is-centered"}>
        <div className="column">
          <Loader />
        </div>
      </div>
    );

    if (!loading && showStream) {
      show = (
        <Player
          id={"stream-player-chartec"}
          file={streamUrl}
          isAutoPlay={true}
        />
      );
    } else if (!loading) {
      show = (
        <a href={academyAgendaUrl} target={"_blank"} rel="noopener noreferrer" >
          <img src={streamOfflineImage} style={{ width: "100%" }} />
        </a>
      );
    }

    return (
      <>
        <Card title={streamNames[streamName] || "Stream"}>
          {show}
          <p>&nbsp;</p>
          <Link to={"/"} className={"btn btn-primary"}>
            <i className="fa fa-arrow-left" /> Back
          </Link>
        </Card>
      </>
    );
  }
}

export default StreamPlayer;



// WEBPACK FOOTER //
// ./app/javascript/components/streaming/StreamPlayer.tsx